import { router } from "expo-router"
import { Pressable } from "react-native"

import { Header } from "@src/components/Header"
import { TransactionForm } from "@src/components/transaction-form/transaction-form"
import { ar } from "@src/i18n/ar"
import { Text } from "@src/components/core"

export default function CreateTransactionScreen() {
  function back() {
    if (router.canGoBack()) router.back()
    else router.replace("/dashboard")
  }

  return (
    <>
      <Header
        title={ar.newTransaction}
        right={
          <Pressable onPress={back} className="h-full px-2 justify-center active:opacity-50">
            <Text className="font-bold text-blue-500">{ar.cancel}</Text>
          </Pressable>
        }
      />

      <TransactionForm />
    </>
  )
}
